var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banner',{staticClass:"feedback-banner"},_vm._l((_vm.bannerLines),function(line,index){return _c('div',{key:index,staticClass:"feedback-banner__line",domProps:{"innerHTML":_vm._s(line)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }